import { Component, OnInit } from '@angular/core';
import { NotificationsService } from "angular2-notifications";

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  public options = {
		position: ["top", "right"],
		timeOut: 3000,
		showProgressBar: false,
		lastOnBottom: false

  }
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/admin/admin.component.ts